import CurrentFundsBalanceError from './CurrentFundsBalanceError';
class CurrentBalanceInvalidPropertyId extends CurrentFundsBalanceError {
    propertyId;
    constructor(propertyId, options) {
        super('The id provided doesn\'t have a valid format', options);
        this.propertyId = propertyId;
    }
}
export default CurrentBalanceInvalidPropertyId;
